import { Veneer } from "./veneer";
import { Crown } from "./crown";
import { Onlay } from "./onlay";
import { Bridge } from "./bridge";
import { Denture } from "./denture";

export const conditions = [Veneer, Crown, Onlay, Bridge, Denture];



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/prostho/index.ts